<div class="payment-result__state payment-result__state--validated">
  <p class="payment-result__lead">✅ Tu pago ha sido validado.</p>
  @if (message().operationNumber || message().currencyAmount || message().paymentDate) {
    <div class="payment-result__details">
      <p>Detalles:</p>
      <ul>
        @if (message().operationNumber) {
          <li>
            <span>N° Operación: </span>
            <strong>{{ message().operationNumber }}</strong>
          </li>
        }
        @if (message().currencyAmount) {
          <li>
            <span>Monto: </span>
            <strong>{{ message().currencyAmount }}</strong>
          </li>
        }
        @if (message().paymentDate) {
          <li>
            <span>Fecha: </span>
            <strong>{{ message().paymentDate }}</strong>
          </li>
        }
      </ul>
    </div>
  }
  <p class="payment-result__closing">Gracias por su espera.</p>
</div>
